export default __webpack_public_path__ + "static/media/circle.c7db43d0.svg";